import { useEffect, useState } from 'react';
import Sheet from './Sheet';
import { PRIMARY } from './CaptureSheets';
import { vnDate } from '../lib/coach';
import { useApp } from '../lib/AppContext';

// ⑮ Shown once after Pro a coach gave has ended: ask the coach to extend (not after being removed), buy Pro,
// or carry on with Free. Also the banner on Today in the last 3 days of a gift.
export default function GiftEndedSheet() {
  const { api, membership, openPaywall } = useApp();
  const [prompt, setPrompt] = useState(null);
  const [asked, setAsked] = useState(false);
  const free = membership && !membership.pro;

  useEffect(() => {
    if (!free) return;
    api.get('/coach_link').then((s) => setPrompt(s.gift_ended_prompt)).catch(() => {});
  }, [api, free]);

  const dismiss = () => {
    setPrompt(null);
    api.post('/coach_link/dismiss_prompt').catch(() => {});
  };

  const askCoach = async () => {
    await api.post('/coach_link/request_renewal').catch(() => {});
    setAsked(true);
    api.post('/coach_link/dismiss_prompt').catch(() => {});
  };

  return (
    <Sheet open={!!prompt} onClose={dismiss} title="Pro Coach tặng đã hết hạn">
      {prompt && (
        <div className="flex flex-col gap-3">
          <p className="text-sm">
            Pro Coach {prompt.coach_name} tặng đã kết thúc ngày {vnDate(prompt.ended_at)}. Bạn đã về bản Free, toàn bộ nhật ký vẫn được giữ nguyên.
          </p>
          {asked ? <p role="status" className="text-center text-sm font-semibold text-brand-text">Đã nhờ Coach {prompt.coach_name} gia hạn</p>
            : prompt.can_ask && <button type="button" className={PRIMARY} onClick={askCoach}>Nhờ Coach {prompt.coach_name} gia hạn</button>}
          <button type="button" className={prompt.can_ask ? 'btn h-12 rounded-2xl font-bold' : PRIMARY}
            onClick={() => { dismiss(); openPaywall('upgrade'); }}>Tự mua Pro</button>
          <button type="button" className="btn btn-ghost h-11 rounded-2xl" onClick={dismiss}>Dùng tiếp bản Free</button>
        </div>
      )}
    </Sheet>
  );
}

// "Pro Coach Minh tặng hết hạn 26/1" on Today, from 3 days before.
export function GiftEndingBanner() {
  const { membership } = useApp();
  const gift = membership?.tier === 'gift' ? membership.gift : null;
  if (!gift?.ends_at || gift.until_cancelled) return null;
  const days = Math.ceil((new Date(gift.ends_at) - Date.now()) / 86400000);
  if (days > 3) return null;
  return (
    <p className="rounded-[16px] bg-[#fdf3d7] px-4 py-3 text-sm text-[#5c4300]">
      Pro Coach {gift.coach_name} tặng hết hạn {vnDate(gift.ends_at)}. Nhờ Coach gia hạn trong Cài đặt › Huấn luyện viên.
    </p>
  );
}
